import services from './../../services/service'; // Service Class
import commons from './../../services/commons'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import ProductList from '../../components/product/ProductList.vue'
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 
import SearchBox from './../../components/templates/searchbox.vue'; 
import Settings from './../../components/tools/settings.vue';
let service = new services();
let set = new commons();

export default {
    name: 'Home',
    data () {
        return {
            user:{},
            market:{},
            business:{},
            categories:{},
            subscriptions:{},
            business_service_categories:[],
            business_product_categories:[],
            business_category_type:0,
            plan1:{},
            plan2:{},
            plan3:{},
            selected_plan:{},
            selected_plan_product_service_item:{},
            upgradable_plans:{},
            upgrade_business:"",
            set_upgrade_plans:false,
            place_order:false,
            //boarding_messages:[],
            data_boarding_message:"",
            set_up_with_existing_account: false,
            set_up_with_new_account:false,
            set_up_business:false,
            validate_user_name_error:false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name:"",
            payment_payer_email:"",
            payment_payer_phone:"",
            payment_service:"",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            action_loading:false,
            disable_btn:false,
            setup_error_message:"",
            newBusinessForm:false,
            product_service_items_select:"",
            set_upgrade_plan_process: false,
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
        'search-box': SearchBox,
        'c-settings':Settings,
    },
    computed: {
        
    },
    methods: {
        setCurrency(currency){
            return set.formatCurrency(currency);
        },

        setComponent(attr1,attr2){
            if(attr1 == 'setup-existing'){
                this.set_up_with_existing_account = true;
            }
            if(attr1 == 'not-setup-existing'){
                this.set_up_with_existing_account = false;
            }
            if(attr1 == 'show-new-business-form'){
                this.newBusinessForm = true;
            }
            if(attr1 == 'display-product_service_items'){
                //toggle display
                var x = document.getElementById("productServiceItems");
                if (x.style.display === "none") {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
            
        },
        reset(){
            this.set_upgrade_plan_process = false;
        },

        toggleDisplayFeatures(){
            var x = document.getElementById("seeFeatures");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        selectProductServiceItem(item){
            this.selected_plan_product_service_item = item;
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;

                            //check for upgrade request
                            if(this.$route.query.upgrade){
                                this.prepareUpgradePlans();
                            }
                        }, this);
                    }else {
                       //this.$router.push('/login/');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('/login/');
                    }
                })
            }else {
               //this.$router.push('/login/');
            }
        },

        setPurchase(){
            //get the route query
            let query_plan = this.$route.query.purchase; //the subscription product-service
            let query_plan_item = this.$route.query.item; //the actual subscription product-service item array index
           
            //set the matching plan
            let found = false;
            //loop through subscriptions
            this.subscriptions.forEach(function(element) {
                if(element.product_url_name == query_plan){
                    this.selected_plan = element;
                    if(query_plan_item != 'n'){ // 'n' is a default mark to show no product item assigned
                        if(element.product_items[query_plan_item]){ //check/confirm if array index exists recode later
                            this.selected_plan_product_service_item = element.product_items[query_plan_item];
                        }else{
                            this.selected_plan_product_service_item = element.product_items[0]; //assign ist in array
                        }
                    }else{
                        this.selected_plan_product_service_item = element.product_items[0]; //still assign ist in array
                    }
                    
                    found = true;
                    //disable loading
                    this.loading = false;
                }
            }, this);
            
            //if noot found
            if(!found){
                this.setup_error_message = "Something went wrong with your selection, please pick another plan"
            }
             //disable loading
            this.loading = false;

        },

        prepareUpgradePlans(){
            this.loading = true;
           
            let navi = this.$router; 
            service.getBusinessMarketUpgradeDetails(this, this.$route.query.upgrade).then(function(data) {
                this.upgradable_plans = data.body.data;
                this.upgrade_business = this.$route.query.upgrade;
                //set payment details
                this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];
                //
                this.set_upgrade_plans = true;
                this.loading = false;
                
            })
        },

        getSellpointMarket(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data;
                    //document.title = this.sellpoint.business_name;
                    
                    //get market details
                    this.getMarketMainProductsAsSubscriptions();
                     

                    this.loading = false;

                }
            }).catch((err) => {
                //log it
                //location.replace("/");
              //console.log(err);
              this.loading = true;
            })
        },
        getMarketMainProductsAsSubscriptions(){
            service.getBusinessProducts(this, this.market.business_id).then(response => {
                if(response.body.status == 200) {
                    this.subscriptions = response.body.data;
                    this.plan1 = this.subscriptions[2];
                    this.plan2 = this.subscriptions[1];
                    this.plan3 = this.subscriptions[0];
                }
                //set up route if available
                if(this.$route.query.purchase){
                    this.setPurchase();
                }
                
            }).catch((err) => {})
                
        },

        purchase_plan_2(plan,plan_product_service_item_index){
            this.loading = true;
            this.$router.push('/purchase/?purchase='+plan.product_url_name+'&item='+plan_product_service_item_index);
            this.setPurchase();
            //srolls to the very top
            var top = document.getElementById("topwrap").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
            window.scrollTo(0, top); 
        },

        purchase_plan(plan){
            this.loading = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0]; //assign ist in array
        },

        upgrade_plan(plan){
            this.loading = true;
            this.set_upgrade_plan_process = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0]; //assign ist in array
            this.loading = false;
        },

        resetOptions(){
            this.selected_plan = {};
            this.selected_plan_product_service_item = {},
            this.total_price = 0;
            this.place_order = false;
        },

        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        proceedUpgradePlan(){
            //loop through plan to get matching price
            let found = false
            this.selected_plan.product_items_upgrade_details.forEach(function(element) {
                if(this.selected_plan_product_service_item.product_item_id == element.subscription_new_product_item_id){
                    this.selected_plan_product_service_item.product_item_price = element.subscription_new_product_total_amount_to_pay;
                    found = true
                }
             }, this);

             if(found){
                //prepare payment details

                //process pay
                this.processPayment();
             }
        },
        
        proceedNewAccount(){
            this.resetMessages();
            this.set_up_with_new_account = true;
            
            // if(this.selected_plan.product_items[0].product_item_price == 0){ //free account
            if(this.selected_plan_product_service_item.product_item_price == 0){ //free account
                this.updatePayment("gw-free-account")
            }else{
                //proceed to pay
                this.processPayment();
            }
                        
            //test-switch
            // this.updatePayment("reffy");
        },

        proceedWithAccount(){
            this.resetMessages();
            this.activate_processing();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            }
            service.checkUserDetails(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    if(data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                        this.deactivate_processing();
                       // toastr.warning("Sorry, Sellpoint does not exist on this account", 'Warning!');
                    }else{
                        this.data_boarding_message = "Account verified...";
                        //all good proceed
                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;
                        
                         // if(this.selected_plan.product_items[0].product_item_price == 0){ //free account
                         if(this.selected_plan_product_service_item.product_item_price == 0){ //free account
                            this.updatePayment("gw-free-account")
                        }else{
                            //proceed to pay
                            this.processPayment();
                        }
                        
                        //test-switch
                        // this.updatePayment("reffy");

                    }
                }else{
                    this.data_error_message = "Sorry, Account does not exist";
                    this.deactivate_processing();
                   // toastr.warning("Sorry, Account does not exist", 'Warning!');
                }
            }).catch((err) => {})
        },

        //connect to a payment gateway
        processPayment() {
            //some onboarding
            this.data_boarding_message = "Preparing Payment Information";
            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                 //process online payment
                    this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name+"("+this.selected_plan.product_items[0].product_item_price+")";
                    let obj = this;
                    //this.amount_paid = data.plan_amount;
                    var handler = PaystackPop.setup({
                    // key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.payment_payer_email,
                    amount:  (Math.round(this.selected_plan_product_service_item.product_item_price * 100)),//(data.plan_amount * 100), //in kobo
                    ref: "GWLOG"+(new Date().getTime()),
                    metadata: {
                        custom_fields: [
                            {
                                display_name: "GalleryWebsite Order",
                                variable_name: "",
                                value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                            },
                            {
                                display_name: "Service",
                                variable_name: "service_type",
                                value: this.selected_plan.product_name
                            }
                            
                        ]
                    },
                    
                    callback: function(response){
                        obj.updatePayment(response.trxref); 
                    },
                    onClose: function(){
                        alert('window closed');
                    }
                    });
                    handler.openIframe();
                }

        },

        // update payments
        updatePayment(payment_ref) {

            //notify server
            //log transctions
            //.......................................

            // var payload = {
            //     payment_order_ref: payment_ref,
            //     payment_user_id: this.user.user_id
            // }
            //.......................................
            
            //then proceed
            let navi = this.$router;

            
            this.payment_successful = true;
            if(this.selected_plan_product_service_item.product_item_price != 0){ //not free account
                this.payment_successful_message = "Payment Successful...";
            }   
            
            //set up account on gw
            if(this.set_up_with_existing_account){
               this.setUpExistingAccount();
            }
            if(this.set_up_with_new_account){
                this.setUpNewAccount();
            }

            //if upgrade process
            if(this.set_upgrade_plan_process){
                this.upgradePlan();
            }
        },

        setUpExistingAccount(){
            //register users business to gallery app
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            }
            
            let navi = this.$router; 
            service.addExistingBusiness(this, credentials).then(function(data) {
                if((data.body.status == 201) || (data.body.status == 200)) {
                    //data.body.status == 200...already exists so login and move to sellpoint..//recode later to inform user
                    //.....usually happens during testings
                    //data.body.status == 201 ...successfully registered..proceed
                    this.data_boarding_message = "Sellpoint Setup Successful...";
                     //navi.push('/'+this.user.user_business);
                    //log user in
                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    }
                    service.loginUser(this, credentials).then(response => {
                        if(response.body.status == 200) {
                            let data = response.body.data;
                            localStorage.setItem("sp_user", data.user_name); 
                            localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                            localStorage.setItem("sp_token_key", data.user_token_key); 
                           
                            //all good
                            //and ask user for business name to create the sp
                           ////DEPRAC $('#purchaseModal').modal('hide');
                            navi.push('/'+this.user.user_business);
                        }
                    }).catch((err) => {
                        if(err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!'); 
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }
            }).catch((err) => {
                if(err) {
                   // console.log(err)
                    //toastr.warning("Something went wrong", 'Warning!'); 
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            })
        },

        setUpNewAccount(){
            //create account by registering user
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address:  '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            }


            let navi = this.$router;

            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                if(credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null &&
                credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                        // toastr.success("Registration Successful", 'Success!');
                        this.data_boarding_message ="Registration Successful...";
                            //log user in
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            }
                            service.loginUser(this, credentials).then(response => {
                                if(response.body.status == 200) {
                                    let data = response.body.data;
                                    localStorage.setItem("sp_user", data.user_name); 
                                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                                    localStorage.setItem("sp_token_key", data.user_token_key); 
                                
                                    //all good
                                    //reauth and preset to get actual user details
                                    this.preset();
                                    //and ask user for business name to create the sp
                                    let self = this;
                                    setTimeout(function(){ 
                                        self.set_up_business = true; 
                                       // $('#purchaseModal').modal('hide');
                                       //DEPRAC $('#newBusinessModal').modal('show');
                                       self.data_boarding_message = " "; //reset
                                       self.setComponent('show-new-business-form','');
                                       self.deactivate_processing();
                                       //srolls to the very top
                                        var top = document.getElementById("banner").offsetTop; //Getting Y of target element //general addPanelView otherwise use specific names
                                        window.scrollTo(0, top); 
                                    }, 3000); //wait for 3sec and c
                                    
                                }
                            }).catch((err) => {
                                if(err.status == 404) {
                                    //toastr.warning("invalid login credentials", 'Warning!'); 
                                    this.data_error_message = "invalid login credentials..";
                                    // this.disable_btn = false;
                                    this.deactivate_processing();
                                }
                            })
                        }else if(data.body.status == 409) {
                            //toastr.warning("This User is already registered", 'Warning!');
                            this.data_error_message = "This User is already registered..";
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields...";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
        },

        validateUserName(){
            service.validateBusinessUserName(this, this.business).then(response => {
                if(response.body.status != 200) {
                    this.validate_user_name_error = true;
                    this.validate_user_name_message = "This username already exist";
                    this.deactivate_processing();
                }
            }).catch((err) => {
                //log it
                this.validate_user_name_error = true;
                this.validate_user_name_message = "This username already exist";
                this.deactivate_processing();
            })
        },
        
        setUpNewAccountBusiness(){
            this.resetMessages();
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 3, //gallery
                business_subscription: this.selected_plan_product_service_item.product_item_id
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
              //  toastr.error('This Username already exists', 'Warning!');
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            // toastr.success("Sellpoint Creation Successfull", 'Success!');
                            this.data_boarding_message = "Sellpoint Creation Successful.";
                                
                            ///DEPRAC//$('#newBusinessModal').modal('hide');
                            navi.push('/'+this.business.business_user_name);
                        }else{
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        if(err) {
                            // toastr.warning("Something went wrong", 'Warning!'); 
                            this.data_error_message = "Something went wrong";
                            // this.disable_btn = false;
                            this.deactivate_processing();
                        }
                    })
                }else {
                    // toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields";
                    // this.disable_btn = false;
                    this.deactivate_processing();
                }
            }
        },
        
        upgradePlan(){
            this.activate_processing();
            var credentials = {
                business_user_name: this.upgrade_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id,
                business_subscription_amount_paid: this.selected_plan_product_service_item.product_item_price,
            }
            
            let navi = this.$router; 
            service.upgradeBusinessMarketSubscription(this, credentials).then(function(data) {
                if(data.body.status ==  200) {
                    //move to the business
                    navi.push('/'+this.upgrade_business);
                }
            }).catch((err) => {
                if(err) {
                    this.data_error_message = "Something went wrong";
                    this.deactivate_processing();
                }
             });
        },

        getBusinessCategories() {
            service.getCategories(this).then(function(data) {
                this.categories = data.body.data;
                //seperate products and services categories
                this.categories.forEach(function(element) {
                    if(element.category_type == 1){
                        this.business_product_categories.push(element);
                    }
                    if(element.category_type == 2){
                        this.business_service_categories.push(element);
                    }
                }, this);
            })
        },
        
    },
    mounted(){
        //always jump to top of page hack
        var top = document.getElementById("topwrap").offsetTop;
        window.scrollTo(0, top); 
        //continue
    },
    created: function(){
        if(this.$route.query.upgrade){
            this.set_upgrade_plans = true; //mus not show purchase section
        }
        this.preset();
        this.getSellpointMarket();
        this.getBusinessCategories();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Purchase/script.js